export const DIGITAL_TOOLS = [
  {
    id: 'I_PREDIX',
    name: 'PrediX™',
    icon: 'menu-ipredix',
    to: '/panel/predix',
    subtitle: 'Alloy Property Prediction',
    description: 'Explore alloy properties and benchmark alloys using Physics-AI-driven predictions.',
    available: true,
    row: 4,
  },
  {
    id: 'I_MAT',
    name: 'AlloyNx™',
    icon: 'menu-imat',
    to: '/panel/module-info/alloynx',
    subtitle: 'Digital Alloy Design',
    description: 'Design and optimise advanced alloys through predictive modelling.',
    available: false,
    row: 4,
  },
  {
    id: 'I_PRO',
    name: 'ProNx™',
    icon: 'menu-ipro',
    to: '/panel/module-info/pronx',
    subtitle: 'Process Optimisation',
    description: 'Optimise manufacturing process parameters using AI/ML models.',
    available: false,
    row: 4,
  },
  {
    id: 'I_ENGINE',
    name: 'EngineX™',
    icon: 'menu-ai-model-development',
    to: '/panel/module-info/enginex',
    subtitle: 'Thermodynamic Screening',
    description: 'High-throughput thermodynamic screening across vast alloy composition spaces.',
    available: false,
    row: 4,
  },
  {
    id: 'I_HEAT',
    name: 'HeatNx™',
    icon: 'menu-iheat',
    to: '/panel/module-info/heatnx',
    subtitle: 'Heat Treatment Toolkit',
    description: 'Optimise thermal processing with AI and metallurgical principles.',
    available: false,
    row: 3,
  },
  {
    id: 'I_BOOST',
    name: 'AlgoNx™',
    icon: 'menu-iboost',
    to: '/panel/module-info/algonx',
    subtitle: 'Model Development',
    description: 'Build robust predictive models using data science and artificial intelligence techniques.',
    available: false,
    row: 3,
  },
  {
    id: 'I_TRAIN',
    name: 'BrainNx™',
    icon: 'menu-itrain',
    to: '/panel/module-info/brainnx',
    subtitle: 'Intelligent Agent',
    description: 'AI expert agent for alloy, process optimisation, and metallurgy.',
    available: false,
    row: 3,
  },
  {
    id: 'I_MELT',
    name: 'MeltNx™',
    icon: 'menu-imelt',
    to: '/panel/module-info/meltnx',
    subtitle: 'Casting Charge Design',
    description: 'Manage material inputs and optimise casting charges.',
    available: false,
    row: 2,
  },
  {
    id: 'I_TARGET',
    name: 'TargetX™',
    icon: 'menu-ipredix',
    to: '/panel/module-info/targetnx',
    subtitle: 'Performance-Driven Selection',
    description: 'Performance-driven alloy selection.',
    available: false,
    row: 2,
  },
]
